import { baseApi, USERS_TAG } from '@/shared';
import { usersAdapter } from '../utils/helpers/adapter';

import type { TGetUsers, TUsersResponse, TUpdateUserParams } from './types';

export const usersApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getUsers: build.query<TUsersResponse, TGetUsers>({
      query: (params: TGetUsers) => ({
        url: '/admin/users/list',
        params: {
          id: params.id,
          created_from: params.createdFrom,
          created_to: params.createdTo,
          email: params.email,
          phone: params.phone,
          name: params.name,
          role: params.role,
          partner_id: params.partnerId,
          is_partner: params.isPartner,
          page_size: params.pageSize,
          page: params.page,
          ascending: params.ascending,
        },
      }),
      transformResponse: usersAdapter,
      providesTags: [USERS_TAG],
    }),

    updateUser: build.mutation<void, TUpdateUserParams>({
      query: ({ userId, partnerId, ...data }: TUpdateUserParams) => ({
        url: `/admin/users/update/${userId}`,
        method: 'PUT',
        body: {
          ...data,
          partner_id: partnerId,
        },
      }),
      invalidatesTags: [USERS_TAG],
    }),

    deleteUser: build.mutation<void, { userId: number }>({
      query: ({ userId }: { userId: number }) => ({
        url: `/admin/users/delete/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [USERS_TAG],
    }),

  }),
});

export const {
  useGetUsersQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = usersApi;
